import { Drawer } from "antd";
import { get, isEmpty, isNil } from "lodash";
import { useEffect, useState } from "react";
import { MdOutlineDescription, MdOutlineFolderOff } from "react-icons/md";
import format from "string-template";
import { useLazyQuery } from "shared/hooks/useApi";
import { ATTACHMENT } from "utils/api/graphql/queries/attachments";

const RangeDrawer = ({ translation: T, documents = [], open, onClose }) => {
  const [selectedId, setSelectedId] = useState(get(documents, [0, "id"]));
  const [resolvedUrl, setResolvedUrl] = useState(null);
  const documentsCopy = T.OFFER.PRODUCT.DOCUMENTS;
  const range = T.PRODUCT.RANGE;
  const selected =
    documents.find(({ id }) => id === selectedId) || documents[0];
  const selectedUrl = resolvedUrl || get(selected, "url");

  const [getAttachment, { loading: urlLoading }] = useLazyQuery(ATTACHMENT, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      setResolvedUrl(get(data, "attachment.fileUrl") || null);
    },
  });

  useEffect(() => {
    setSelectedId(get(documents, [0, "id"]));
  }, [documents]);

  const selectedAttachmentId = get(selected, "id");
  const selectedAttachmentUrl = get(selected, "url");

  useEffect(() => {
    setResolvedUrl(selectedAttachmentUrl || null);
    if (open && selectedAttachmentId && isNil(selectedAttachmentUrl)) {
      getAttachment({
        variables: { where: { id: selectedAttachmentId } },
      });
    }
  }, [getAttachment, open, selectedAttachmentId, selectedAttachmentUrl]);

  return (
    <Drawer
      className="drawer__area ac-collectif__range-drawer"
      title={documentsCopy.TITLE}
      width={760}
      onClose={onClose}
      open={open}
      placement="right"
    >
      <div className="ac-collectif__range">
        <p className="ac-collectif__range-description">
          {format(documentsCopy.DESCRIPTION, { range })}
        </p>

        {isEmpty(documents) ? (
          <div className="ac-collectif__range-empty">
            <MdOutlineFolderOff size={40} />
            <strong>{documentsCopy.NONE.TITLE}</strong>
            <span>{documentsCopy.NONE.DESCRIPTION}</span>
          </div>
        ) : (
          <>
            <ul className="ac-collectif__range-list">
              {documents.map((document) => (
                <li key={document.id}>
                  <button
                    type="button"
                    aria-pressed={document.id === get(selected, "id")}
                    className={`ac-collectif__range-item${
                      document.id === get(selected, "id")
                        ? " ac-collectif__range-item--selected"
                        : ""
                    }`}
                    onClick={() => setSelectedId(document.id)}
                  >
                    <span className="ac-collectif__range-item-icon">
                      <MdOutlineDescription size={18} />
                    </span>
                    <span className="ac-collectif__range-item-text">
                      <span className="ac-collectif__range-item-name">
                        {document.name}
                      </span>
                      <span className="ac-collectif__range-item-description">
                        {document.description}
                      </span>
                    </span>
                  </button>
                </li>
              ))}
            </ul>

            <div className="ac-collectif__range-viewer">
              {urlLoading && (
                <div className="ac-collectif__range-empty">
                  <strong>{documentsCopy.LOADING}</strong>
                </div>
              )}
              {!urlLoading && isNil(selectedUrl) && (
                <div className="ac-collectif__range-empty">
                  <MdOutlineFolderOff size={40} />
                  <strong>{documentsCopy.EMPTY.TITLE}</strong>
                  <span>{documentsCopy.EMPTY.DESCRIPTION}</span>
                </div>
              )}
              {!urlLoading && !isNil(selectedUrl) && (
                <>
                  <iframe title={get(selected, "name")} src={selectedUrl} />
                  <a
                    className="ac-collectif__range-open"
                    href={selectedUrl}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {documentsCopy.OPEN}
                  </a>
                </>
              )}
            </div>
          </>
        )}
      </div>
    </Drawer>
  );
};

export default RangeDrawer;
